import type {Grouping, _Grouping} from './grouping';
import type {GroupingResult, _GroupingResult} from './grouping-result';

/**
 * Generated from com.dataiku.dip.eda.compute.grouping.CrossGrouping
 */
export interface CrossGrouping extends _Grouping {
    groupings: Grouping[];

    // PolyJson type
    type: 'cross';
}

export namespace CrossGrouping {
    export const type = 'cross';
}

/** @deprecated Use Grouping.isCrossGrouping() */ export function isCrossGrouping(toTest: Grouping): toTest is CrossGrouping { return CrossGrouping.type === toTest['type']; }

export namespace CrossGrouping {
    /**
     * Generated from com.dataiku.dip.eda.compute.grouping.CrossGrouping$CrossGroupingResult
     */
    export interface CrossGroupingResult extends _GroupingResult {
        groups: GroupingResult[];

        // PolyJson type
        type: 'cross';
    }

    export namespace CrossGroupingResult {
        export const type = 'cross';
    }

    /** @deprecated Use GroupingResult.isCrossGroupingResult() */ export function isCrossGroupingResult(toTest: GroupingResult): toTest is CrossGroupingResult { return CrossGroupingResult.type === toTest['type']; }
}